<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.alergia"
        ref="DataTable"
        sort-by="agenteSubstanciaEspecifica"
        search-by="agenteSubstanciaEspecifica"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'cadastro-alergia-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-cadastro-alergia"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-cadastro-alergia"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    activated() {

        this.$refs.DataTable.refresh()
    },
    created() {

        this.repositories.alergia = this.getConectaSusRepository('cadastro.sujeitoAtencao.alergia')
    },
    data: () => ({
        fields: [
            {
                name: 'cadastroAlergiaTipo.descricao',
                key: 'tipoDescricao',
                label: 'Tipo',
                searchable: true,
                sortable: true,
                class: 'col-min'
            },
            {
                name: 'cadastroAlergia.agenteSubstanciaEspecifica',
                key: 'agenteSubstanciaEspecifica',
                label: 'Agente / substância específica',
                searchable: true,
                sortable: true
            },
            {
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        repositories: {
            alergia: null,
        },
    }),
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.alergia.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a alergia?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ],
}
</script>